import DateRangePicker from './components/DateRangePicker.vue'

export default DateRangePicker
